// Translations object with all text content
export const translations = {
  pt: {
    // Header buttons
    language: 'EN',
    controls: 'Controles',
    currentParcel: 'Terreno #',
    // Controls modal
    controlsTitle: 'Controles',
    controlsText: `
      W - Mover para frente
      S - Mover para trás
      A - Mover para esquerda
      D - Mover para direita
      Espaço - Subir/Pular
      Control - Descer
      Shift - Movimento 2x mais rápido
      R - Reposicionar
      Mouse (Arrastar) - Girar câmera
      Scroll - Zoom
    `,
    // Search
    searchPlaceholder: 'Número do terreno',
    parcel: 'Terreno',
    searchButton: 'Ir',
    // Chat
    onlineUsers: 'Usuários Online',
    connected: 'Conectado',
    connecting: 'Conectando...',
    disconnected: 'Desconectado',
    messageInputPlaceholder: 'Digite sua mensagem...',
    sendButton: 'Enviar',
    you: 'Você',
    // Block info
    block: 'Terreno',
    size: 'Tamanho',
    // Audio controls
    enterVoiceRoom: 'Entrar',
    leaveVoiceRoom: 'Sair',
    enableMicrophone: 'Ativar Microfone',
    disableMicrophone: 'Desativar Microfone',
    enableAudio: 'Ativar Áudio',
    disableAudio: 'Desativar Áudio',
    voiceRoomParticipants: 'Participantes na sala de voz',
    sessionTimeWarning15: 'Sua sessão de áudio será encerrada em aproximadamente 15 minutos.',
    sessionTimeWarning5: 'Sua sessão de áudio será encerrada em aproximadamente 5 minutos.',
    sessionTimeEnded: 'Sua sessão de áudio foi encerrada após {minutes} minutos.',
    sessionTimeWarningTitle: 'Aviso de Tempo de Sessão',
    sessionEndedTitle: 'Sessão Encerrada',
    // Wallet Connect
    connectWallet: 'Conectar Carteira',
    disconnectWallet: 'Desconectar',
    connecting: 'Conectando...',
    authenticate: 'Autenticar',
    authenticating: 'Autenticando...',
    requestingSignature: 'Solicitando assinatura...',
    verifyingSignature: 'Verificando assinatura e validando Ordinals...',
    accessGranted: 'Multiverso Pass verificado',
    accessDenied: 'Você não possui um Multiverso Pass nesta carteira.'
  },
  en: {
    // Header buttons
    language: 'PT',
    controls: 'Controls',
    currentParcel: 'Parcel #',
    noParcel: 'Flying outside parcels',
    // Controls modal
    controlsTitle: 'Controls',
    controlsText: `
      W - Move forward
      S - Move backward
      A - Move left
      D - Move right
      Space - Move up/Jump
      Control - Move down
      Shift - Move 2x faster
      R - Reset position
      Mouse (Drag) - Rotate camera
      Scroll - Zoom
    `,
    // Search
    searchPlaceholder: 'Parcel number',
    parcel: 'Parcel',
    searchButton: 'Go',
    // Chat
    onlineUsers: 'Online Users',
    connected: 'Connected',
    connecting: 'Connecting...',
    disconnected: 'Disconnected',
    messageInputPlaceholder: 'Type your message...',
    sendButton: 'Send',
    you: 'You',
    // Block info
    block: 'Parcel',
    size: 'Size',
    // Audio controls
    enterVoiceRoom: 'Join',
    leaveVoiceRoom: 'Leave',
    enableMicrophone: 'Enable Microphone',
    disableMicrophone: 'Disable Microphone',
    enableAudio: 'Enable Audio',
    disableAudio: 'Disable Audio',
    voiceRoomParticipants: 'Voice room participants',
    sessionTimeWarning15: 'Your audio session will end in approximately 15 minutes.',
    sessionTimeWarning5: 'Your audio session will end in approximately 5 minutes.',
    sessionTimeEnded: 'Your audio session has ended after {minutes} minutes.',
    sessionTimeWarningTitle: 'Session Time Warning',
    sessionEndedTitle: 'Session Ended',
    // Wallet Connect
    connectWallet: 'Connect Wallet',
    disconnectWallet: 'Disconnect',
    connecting: 'Connecting...',
    authenticate: 'Authenticate',
    authenticating: 'Authenticating...',
    requestingSignature: 'Requesting signature...',
    verifyingSignature: 'Verifying signature and validating Ordinals...',
    accessGranted: 'Multiverso Pass verified',
    accessDenied: 'You don\'t have a Multiverso Pass in this wallet.'
  }
}